import { SelectOption } from 'basics/options/options.types';
import { TargetsFacets } from 'generated/maya.types';

const useTargetsFiltersOptions = (targetFilter: TargetsFacets): {
  types?: SelectOption[];
  countries?: SelectOption[];
  businessUnits?: SelectOption[];
  specialties?: SelectOption[];
  smaSegments?: SelectOption[];
  biosSegments?: SelectOption[];
  imsSegments?: SelectOption[];
} => {
  if (!targetFilter) {
    return {};
  }

  const typesOptions = targetFilter.types ? targetFilter.types.map((element: string) => {
    return {
      id: element,
      label: element,
    };
  }) : [];

  const countriesOptions = targetFilter.country ? targetFilter.country.map((element: string) => {
    return {
      id: element,
      label: element,
    };
  }) : [];

  const businessUnitsOptions = targetFilter.businessUnits ? targetFilter.businessUnits.map((element: string) => {
    return {
      id: element,
      label: element,
    };
  }) : [];

  const specialtiesOptions = targetFilter.specialties ? targetFilter.specialties.map((element: string) => {
    return {
      id: element,
      label: element,
    };
  }) : [];

  const smaSegmentsOptions = targetFilter.smaSegments ? targetFilter.smaSegments.map((element: string) => {
    return {
      id: element,
      label: element,
    };
  }) : [];

  const biosSegmentsOptions = targetFilter.biosSegments ? targetFilter.biosSegments.map((element: string) => {
    return {
      id: element,
      label: element,
    };
  }) : [];

  const imsSegmentsOptions = targetFilter.imsSegments ? targetFilter.imsSegments.map((element: string) => {
    return {
      id: element,
      label: element,
    };
  }) : [];

  const targetsFiltersOptions = {
    types: typesOptions,
    countries: countriesOptions,
    businessUnits: businessUnitsOptions,
    specialties: specialtiesOptions,
    smaSegments: smaSegmentsOptions,
    biosSegments: biosSegmentsOptions,
    imsSegments: imsSegmentsOptions,
  };

  return targetsFiltersOptions;
};

export default useTargetsFiltersOptions;
